import account from './account'
import filters from './filters'
import transactions from './transactions'
import journeys from './journeys'
import products from './products'
import tnes from './tnes'

export default {
  user: {
    namespaced: true,
    actions: {
      /**
       * Restablece todos los datos privados del usuario conservados durante la sesión.
       * La configuración pública del cliente y del municipio se mantiene intacta.
       */
      resetSessionState({commit}) {
        commit('setCurrentUser', undefined, {root: true})
        commit('setFullClient', {})
        commit('setMediaTypes', [])
        commit('setClientData', [])
        commit('setLoadingTravels', false)
        commit('setTransactions', [])
        commit('setTscs', [])
        commit('setOkProfile', false)
        commit('setCurrentAlias', false)
        commit('setSelectedTscMediaCode', '')
        commit('setTravels', [])
        commit('setProducts', [])
        commit('setPaymentMethod', '')
        commit('setMediaType', '')
        commit('closeModalCapping')
      }
    },
    modules: {
      ...account,
      ...filters,
      ...transactions,
      ...journeys,
      ...products,
      ...tnes
    }
  }
}
